var React = require('react');
var BrandPage = require('./brands-page');

module.exports = React.createClass({

  componentDidMount: function() {
    document.title = "Brands for Men - Ingledew's Shoes";
  },

  render: function() {

    return <BrandPage gender="mens" prefix={CMS.brands.prefixM} title={CMS.brands.titleM}
                      desc={CMS.brands.descM} image={CMS.brands.imgM} />
  }
});